import type { IconSvgObject } from './types';

const Navigator02Icon: IconSvgObject = [
  ["path", { d: "M20.9961 20H2.99609M2.99609 4L20.9961 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 11.9997L3 8L4.55591 12.0001L3.0005 16L10 11.9997Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 12H19M16 12H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Navigator02Icon;
